(function() {
    'use strict';

    angular.module('GorillaBoy.directives')
    .directive('gbOrgUserSelect', [
        '$rootScope',
        '$log',
        '$q',
        '$timeout',
        '$translate',
        '$filter',
        'focus',
        'searchDelay',
        'OrganizationService',
        OrgUserSelectDirective
    ]);

    function OrgUserSelectDirective ($rootScope, $log, $q, $timeout, $translate, $filter, focus, searchDelay, OrganizationService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                user: '=user'
            },
            link: function(scope, element, attrs) {
                var typeAheadTimeoutPromise = null;
                scope.userInput = '';
                scope.USER_INPUT_SIGNAL = 'USER_INPUT_SIGNAL';

                $timeout(function () {
                    focus(scope.USER_INPUT_SIGNAL);
                }, 0);

                scope.searchOrgUsers = function(query) {
                    if (!!typeAheadTimeoutPromise) {
                        $timeout.cancel(typeAheadTimeoutPromise);
                    }
                    typeAheadTimeoutPromise = $timeout(function () {
                        return OrganizationService.searchUsers(query, { includeInactiveUsers: true });
                    }, searchDelay(query));
                    return typeAheadTimeoutPromise;
                };

                scope.typeAheadSelect = function(item) {
                    scope.user = item;
                    scope.userInput = item.GivenName + ' ' + item.Surname;
                };
                scope.$watch(
                    function() {
                        return $filter('translate')('ADMIN.EDIT_USER_MODAL.TYPE_EMAIL'); 
                    },
                    function(translatedValue) {
                        scope.text = translatedValue;
                    }
                );
            },
            template: '<input type="text" class="select-user-text" ng-model="userInput"' +
                      'typeahead="user.displayName for user in searchOrgUsers($viewValue)"' +
                      'typeahead-on-select="typeAheadSelect($item)"' +
                      'typeahead-editable="false"' +
                      'placeholder= {{text}} gb-focus-on="{{USER_INPUT_SIGNAL}}" />'
        };
    }
}());
